export const Permission = {
  Users: {
    Read: 'users.read',
    Create: 'users.create',
    Update: 'users.update',
    Deactivate: 'users.deactivate',
    AssignRoles: 'users.assign-roles',
    ResetPassword: 'users.reset-password',
  },
  Roles: {
    Read: 'roles.read',
    Create: 'roles.create',
    Update: 'roles.update',
    Delete: 'roles.delete',
    AssignPermissions: 'roles.assign-permissions',
  },
  Permissions: {
    Read: 'permissions.read',
  },
  Company: {
    Read: 'company.read',
    Update: 'company.update',
    UpdateLogo: 'company.logo.update',
  },
  Customers: {
    Read: 'customers.read',
    Create: 'customers.create',
    Update: 'customers.update',
    Delete: 'customers.delete',
    Restore: 'customers.restore',
    PermanentlyDelete: 'customers.permanently-delete',
  },
  Inquiries: {
    Read: 'inquiries.read',
    Create: 'inquiries.create',
    Update: 'inquiries.update',
    ConvertToTrip: 'inquiries.convert-to-trip',
  },
  Trips: {
    Read: 'trips.read',
    Update: 'trips.update',
  },
  Itinerary: {
    Read: 'itinerary.read',
    Update: 'itinerary.update',
  },
  ServiceRequirements: {
    Read: 'service-requirements.read',
    Update: 'service-requirements.update',
  },
  Suppliers: {
    Read: 'suppliers.read',
    Create: 'suppliers.create',
    Update: 'suppliers.update',
  },
  Activities: {
    Read: 'activities.read',
    Manage: 'activities.manage',
  },
  SupplierRequests: {
    Read: 'supplier-requests.read',
    Create: 'supplier-requests.create',
    Send: 'supplier-requests.send',
  },
  SupplierOffers: {
    Read: 'supplier-offers.read',
    Record: 'supplier-offers.record',
    Select: 'supplier-offers.select',
  },
  Costings: {
    Read: 'costings.read',
    Update: 'costings.update',
  },
  ExchangeRates: {
    Read: 'exchange-rates.read',
    Manage: 'exchange-rates.manage',
  },
  Quotations: {
    Read: 'quotations.read',
    Create: 'quotations.create',
    Update: 'quotations.update',
    Submit: 'quotations.submit',
    Approve: 'quotations.approve',
    Send: 'quotations.send',
  },

  /*
   * Booking, operations and finance are frontend-only for now: the API issues
   * none of these permissions, so nothing may be guarded by them yet - the
   * routes fall back to the permission of the stage each one follows
   * (see app.routes.ts). They are listed here so that, once the backend seeds
   * them, switching a guard over is a one-line change and the strings already
   * agree with the module/feature/action scheme the permissions matrix expects.
   */
  Bookings: {
    Read: 'bookings.read',
    Create: 'bookings.create',
    Update: 'bookings.update',
    Confirm: 'bookings.confirm',
    Cancel: 'bookings.cancel',
  },
  SupplierConfirmations: {
    Read: 'supplier-confirmations.read',
    Request: 'supplier-confirmations.request',
    Confirm: 'supplier-confirmations.confirm',
    Reject: 'supplier-confirmations.reject',
  },
  Operations: {
    Read: 'operations.read',
    Update: 'operations.update',
    Complete: 'operations.complete',
  },
  Invoices: {
    Read: 'invoices.read',
    Create: 'invoices.create',
    Issue: 'invoices.issue',
    Cancel: 'invoices.cancel',
  },
  Payments: {
    Read: 'payments.read',
    Record: 'payments.record',
    SendLink: 'payments.send-link',
    Refund: 'payments.refund',
  },
  Settlements: {
    Read: 'settlements.read',
    Schedule: 'settlements.schedule',
    Pay: 'settlements.pay',
    Cancel: 'settlements.cancel',
  },
  CompanyPaymentSettings: {
    Read: 'company.payment-settings.read',
    Update: 'company.payment-settings.update',
  },
} as const;
